/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentHeaderViewModel } from "../types/IndividualPaymentHeaderViewModel.ts";
import { individualPaymentHeaderDiscountViewModelSchema } from "./individualPaymentHeaderDiscountViewModelSchema.ts";

export const individualPaymentHeaderViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  courseRegistrationCompanyId: z.number().int().nullish(),
  type: z.optional(z.number().int()),
  typeText: z.string().nullish(),
  status: z.optional(z.number().int()),
  statusText: z.string().nullish(),
  renegotiationApproveDate: z.string().datetime().nullish(),
  email: z.string().nullish(),
  courseName: z.string().nullish(),
  numberParcels: z.optional(z.number().int()),
  totalValue: z.optional(z.number()),
  totalTransf: z.optional(z.number()),
  valueRegistration: z.optional(z.number()),
  studentName: z.string().nullish(),
  paymentType: z.optional(z.number().int()),
  paymentTypeText: z.string().nullish(),
  refundSendMail: z.optional(z.boolean()),
  refundCreditCard: z.optional(z.boolean()),
  cpfCnpj: z.string().nullish(),
  companyName: z.string().nullish(),
  personId: z.optional(z.number().int()),
  forceCreditCardPecegePay: z.optional(z.boolean()),
  forceBilletPecegePay: z.optional(z.boolean()),
  merchantName: z.string().nullish(),
  projectParcelCode: z.string().nullish(),
  projectParcelEnrollment: z.string().nullish(),
  lastCreditCard: z.string().nullish(),
  totalValuePaid: z.number().nullish(),
  totalValueWithDiscount: z.optional(z.number()),
  totalValueWithScholarShipDiscount: z.number().nullish(),
  validations: z.array(z.string()).nullish(),
  discounts: z
    .array(z.lazy(() => individualPaymentHeaderDiscountViewModelSchema))
    .nullish(),
}) as unknown as ToZod<IndividualPaymentHeaderViewModel>;
